export default __webpack_public_path__ + "static/avatar-1-75d8b45c5c3ade7d851cc983aab28abc.jpg";